import { Component, Input, OnInit } from '@angular/core';
import { TalentHappyPathDataService } from '../../shared/service/talent-happy-path-data-service';
import { InitialInterviewQuestion } from 'src/typings';
import { PageService } from '../service/page-service';
import { InitialInterviewPage } from 'src/app/enums';

@Component({
  selector: 'app-initial-interview-welcome-back-page',
  standalone: false,
  templateUrl: './initial-interview-welcome-back-page.component.html',
  styleUrl: './initial-interview-welcome-back-page.component.scss'
})
export class InitialInterviewWelcomeBackPageComponent implements OnInit {

  talentName: string = '';

  constructor(
    private talentHappyPathDataService: TalentHappyPathDataService,
    private pageService: PageService) {
  }

  ngOnInit(): void {
    this.talentHappyPathDataService.talent$.subscribe(talent =>
        this.talentName = talent.preferredName ? talent.preferredName : talent.firstName);
  }

  navigateToSplashPage() {
      this.pageService.setActivePage(InitialInterviewPage.SPLASH_PAGE);
  }

}
